import React, { useState, useEffect, useRef, useCallback, useContext, useMemo } from "react";
import { Form, InputGroup, Media, Col, Alert, Row, OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import ModalDommus from "../../../../../components/Modal";
import ConclusaoChamado from "./ConclusaoChamado";
import { Icon } from "@iconify/react";
import pageDoc from "@iconify-icons/foundation/page-doc";
import searchOutlined from "@iconify-icons/ant-design/search-outlined";
import editFilled from '@iconify-icons/ant-design/edit-filled';
import "./coluna_esquerda.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { parseISO, format } from "date-fns";
import guService from "../../../../../services/GuService";
import DommusToggle from "../../../../../components/DommusToggle";
import { trackPromise } from "react-promise-tracker";
import ticketCategoria from "../../../../../services/TicketCategoriaService";
import ticketMotivo from "../../../../../services/TicketMotivoService";
import ticketStatus from "../../../../../services/TicketStatusService";
import ticketTipo from "../../../../../services/TicketTipoService";
import ticketTags from "../../../../../services/TicketTagsService";
import ticketPrioridade from "../../../../../services/TicketPrioridadeService";
import moduloService from "../../../../../services/ModuloService";
import equipeService from "../../../../../services/EquipeService";
import ticketSubStatus from "../../../../../services/TicketSubStatusService";
import ProcessoService from "../../../../../services/ProcessoService";
import departamentoService from "../../../../../services/DepartamentoService";
import helper from "../../../../../helpers/format";
import Swal from "sweetalert2";
import ticketService from "../../../../../services/TicketService";
import urlHelper from "../../../../../helpers/UrlHelper";
import { errorToast } from "../../../../../components/DommusToast";
import ValidaTipoArquivo from "../../../../../helpers/ValidaTipoArquivo";
import { InternalNoteStatus } from "../../ModificarStatus/InternalNote";
import { ChamadoContext, EquipesContext } from "../../../../../components/ContextoGlobal";
import { cachearContexto } from "../../../../../helpers/cachearContexto";
import convertFilesToBase64 from "../../../../../helpers/ConvertFilesToBase64";
import { DommusBadgesResposaveis } from "../../../../../components/DommusBadgesResposaveis";
import MeioComunicacaoIcone from "../../../../../components/MeioComunicacaoIcone";
import { DommusThumbnail } from "../../../../../components/DommusThumbnail";
import { celularMask, cepMask, cpfMask, handleFormataDocumentoProponente, realMoeda } from "../../../../../components/InputTextMask";
import { IconePrioridade } from "../../../../../components/IconePrioridade";
import { ConfiguracaoContext } from "../../../../../contexts/ConfiguracaoContext";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import DommusRequiredSpan from "../../../../../components/DommusRequiredSpan";
import TicketStatus from "../../../../../services/TicketStatusService";
import { EnumTipoCampoDinamico } from "../../../../../contexts/CampoDinamicoContext/types";


export default function Coluna_esquerda({
  ticket,
  close,
  setRefresh,
  refresh,
  recarregarDadosChamado,
  setRecarregarDadosChamado
}) {

  const [chamado, setChamado] = useState(ticket);
  const [solicitante, setSolicitante] = useState(chamado?.solicitante);
  const [processoBusca, setProcessoBusca] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [processo, setProcesso] = useState(
    chamado?.id_processo ? helper.zeroPad(chamado?.id_processo, 5) : ""
  );
  const [dataCadastro, setDataCadastro] = useState(chamado?.criado_em || "");
  const [situacao, setSituacao] = useState(
    chamado?.status?.id_ticket_status || ""
  );
  const [subSituacao, setSubSituacao] = useState(
    chamado?.substatus == null ? "" : chamado?.substatus?.id_ticket_substatus
  );
  const [assunto, setAssunto] = useState(chamado?.assunto || "");
  const [descricao, setDescricao] = useState(chamado?.descricao || "");
  const [tipo, setTipo] = useState(chamado?.tipo?.id_ticket_tipo || "");
  const [categoria, setCategoria] = useState(
    chamado?.categoria?.id_ticket_categoria || ""
  );
  const [modulo, setModulo] = useState(
    chamado?.categoria?.id_modulo || ""
  );
  const [motivo, setMotivo] = useState(chamado?.motivo?.id_ticket_motivo || "");
  const [listaArquivos, setListaArquivos] = useState([]);
  const [prioridade, setPrioridade] = useState(
    chamado?.prioridade?.id_ticket_prioridade || ""
  );
  const [dataLimite, setDataLimite] = useState(chamado.prazo_sla == null ? "" : chamado?.prazo_sla);
  const [responsavelExecucao, setResponsavelExecucao] = useState(
    chamado?.responsaveis_execucao || []
  );
  const [departamentosExecucao, setDepartamentosExecucao] = useState(
    chamado?.departamentos_execucao || []
  );
  const [departamentoAutorizacao, setDepartamentoAutorizacao] = useState(
    chamado?.departamentos_autorizacao || []
  );
  const [departamentoAprovacao, setDepartamentoAprovacao] = useState(
    chamado?.departamentos_aprovacao || []
  );
  const [departamentoAcompanhamento, setDepartamentoAcompanhamento] = useState(
    chamado?.departamentos_acompanhamento || []
  );
  const [responsavelAutorizacao, setResponsavelAutorizacao] = useState(
    chamado?.responsaveis_autorizacao || []
  );
  const [responsavelAprovacao, setResponsavelAprovacao] = useState(
    chamado?.responsaveis_aprovacao || []
  );
  const [acompanhamento, setAcompanhamento] = useState(
    chamado?.usuarios_acompanhamento || []
  );
  const [empreendimentoNome, setEmpreendimentoNome] = useState(
    chamado?.nome_empreendimento || ""
  );
  const [primeiroProponente, setPrimeiroProponente] = useState(
    {
      "nome": chamado?.proponentes?.proponente1,
      "cpf": chamado?.proponentes?.proponente1_cpf,
    }
  );
  const [dadosEmpreendimento, setDadosEmpreendimento] = useState(
    chamado?.dados_empreendimento || null
  );

  const [camposDinamicosRespostas, setCamposDinamicosRespostas] = useState(chamado?.campos_dinamicos_respostas ?? {});
  const [tags, setTags] = useState(chamado.tags || []);

  const [listaTipos, setListaTipos] = useState([]);
  const [listaCategorias, setListaCategorias] = useState([]);
  const [listaModulos, setListaModulos] = useState([]);
  const [listaTags, setListaTags] = useState([]);
  const [listaMotivos, setListaMotivos] = useState([]);
  const [listaSubStatus, setListaSubStatus] = useState([]);
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [listaPrioridades, setListaPrioridades] = useState([]);
  const [listaResponsaveis, setListaResponsaveis] = useState([]);
  const [modalConclusao, setModalConclusao] = useState(false);
  const [listaDepartamentos, setListaDepartamentos] = useState([]);
  const [dadosConclusao, setDadosConclusao] = useState([]);
  const [autorizado, setAutorizado] = useState(false);
  const [aprovado, setAprovado] = useState(false);
  const [statusMudou, setStatusMudou] = useState(false);
  const [modalNotaInterna, setModalNotaInterna] = useState(false);
  const [meioComunicacao, setMeioComunicacao] = useState(chamado?.origem_ticket);
  const [listaMeioComunicacao, setListaMeioComunicacao] = useState([]);
  const [habilitarEdicaoChamado, setHabilitarEdicaoChamado] = useState(false);
  const [habilitarEdicaoQualificacao, setHabilitarEdicaoQualificacao] = useState(false);
  const [habilitarEdicaoCamposDinamicos, setHabilitarEdicaoCamposDinamicos] = useState(false);
  const {listaConfiguracoes, buscarConfiguracaoPorChave} = useContext(ConfiguracaoContext);
  const usaModuloTicket = buscarConfiguracaoPorChave('habilitar_modulo_ticket');

  const [arquivo, setArquivo] = useState([]);
  const contextoChamados = useContext(ChamadoContext)
  const contextoEquipes = useContext(EquipesContext)

  useEffect(() => {
    buscarArquivos();
    trackPromise(ticketService.buscaMeiosComunicacao()
      .then((response) => {
        setListaMeioComunicacao(Object.values(response.data));
      }).catch(() => {
        Swal.fire({
          title: 'Ooops...', 
          text: 'Ocorreu um erro ao carregar os Meios de Comunicação.', 
          icon: 'error',
          confirmButtonText: `Recarregar`
        }).then((result) => {
          if(result.isConfirmed) {
            setRecarregarDadosChamado(!recarregarDadosChamado)
          }
        })
      })
    );
  }, [recarregarDadosChamado, refresh])

  useEffect(()=>{
    if(ticket){
      setChamado(ticket)
    }
  },[ticket])

  const habilitarReabrirChamado = useMemo(()=>{
    let permissaoReabrir = listaConfiguracoes.find((item) => item.chave === "tipos_usuarios_permite_reabertura_chamado");
    if(chamado?.conclusao?.data_conclusao && chamado?.status?.tipo === "F"){
      if(permissaoReabrir && permissaoReabrir?.valor?.length && permissaoReabrir.valor.includes(Number(guService.getLocalState("tipoUsuario")))){
        return true;
      }else if(!chamado?.motivo.dias_reabertura_chamado){
        return false;
      }else if(moment(chamado?.conclusao?.data_conclusao).days(chamado?.motivo.dias_reabertura_chamado) < moment()){
        return false;
      }else{
        return true;
      }
    }
    return true;
  },[chamado?.conclusao?.data_conclusao])

  const mostrarCodigoRelacionamento = useMemo(()=>{
    const permissao = listaConfiguracoes.find((item) => item.chave === "ativar_codigo_relacionamento");
    return Number(permissao.valor);
  },[listaConfiguracoes])

  useEffect(() => {
    cachearContexto(contextoChamados.ticketCategoria, contextoChamados.setTicketCategoria, ticketCategoria.index)
    cachearContexto(contextoChamados.ticketMotivo, contextoChamados.setTicketMotivo, ticketMotivo.index)
    cachearContexto(contextoChamados.ticketStatus, contextoChamados.setTicketStatus, ticketStatus.index)
    cachearContexto(contextoChamados.ticketTipo, contextoChamados.setTicketTipo, ticketTipo.index)
    cachearContexto(contextoChamados.ticketPrioridade, contextoChamados.setTicketPrioridade, ticketPrioridade.index)
    cachearContexto(contextoEquipes.usuarios, contextoEquipes.setUsuarios, equipeService.index)
    cachearContexto(contextoChamados.ticketTags, contextoChamados.setTicketTags, ticketTags.index)
    cachearContexto(contextoChamados.ticketSubStatus, contextoChamados.setTicketSubStatus, ticketSubStatus.index)
    cachearContexto(contextoEquipes.departamentos, contextoEquipes.setDepartamentos, departamentoService.index)
    cachearContexto(contextoChamados.moduloService, contextoChamados.setModuloService, moduloService.buscarModulosPorClienteUsuario)
  }, []);

  const buscarStatusTicket = ()=>{

    trackPromise(TicketStatus.buscarStatusPorFluxoTicket(chamado.id_ticket)).then((response) => {
      contextoChamados.setListaStatus(response?.data ?? contextoChamados.ticketStatus);
    }).catch((error)=>{
      contextoChamados.setListaStatus(contextoChamados.ticketStatus)
    })
  }

  useEffect(() => {
    setListaDepartamentos(contextoEquipes.departamentos)
    montaListaResponsaveis(contextoEquipes.usuarios, contextoEquipes.departamentos);
  }, [contextoEquipes.departamentos, contextoEquipes.usuarios])

  useEffect(() => {
    montaListaTags(contextoChamados.ticketTags)
  }, [contextoChamados.ticketTags])

  useEffect(() => {
    setListaUsuarios(contextoEquipes.usuarios)
  }, [contextoEquipes.usuarios])

  useEffect(() => {
    setListaCategorias(contextoChamados.ticketCategoria)
  }, [contextoChamados.ticketCategoria])

  useEffect(() => {
    setListaModulos(contextoChamados.moduloService)
  }, [contextoChamados.moduloService])

  useEffect(() => {
    setListaMotivos(contextoChamados.ticketMotivo)
  }, [contextoChamados.ticketMotivo])

  useEffect(() => {
    contextoChamados.buscarStatusTicketFluxo(chamado?.id_ticket);
  }, [chamado])

  useEffect(() => {
    if(contextoChamados.listaStatus.length && situacao){
      let temp = contextoChamados.listaStatus.find((item)=>item.id_ticket_status === Number(situacao));
      setListaSubStatus(temp?.substatus ?? []);
    }
  },[contextoChamados.listaStatus, situacao, chamado])

  useEffect(() => {
    setListaTipos(contextoChamados.ticketTipo)
  }, [contextoChamados.ticketTipo])

  useEffect(() => {
    setListaPrioridades(contextoChamados.ticketPrioridade)
  }, [contextoChamados.ticketPrioridade])

  useEffect(() => {
    if((chamado?.status?.id_ticket_status !== situacao) || (chamado?.status?.id_ticket_substatus !== subSituacao)){
      setSituacao(chamado?.status?.id_ticket_status); 
      setSubSituacao(chamado?.status?.id_ticket_substatus)
      setStatusMudou(true);
    }
  },[chamado])


  function buscarArquivos (){
    trackPromise(ticketService.getArquivos(chamado.id_ticket)
      .then((response) => {
        const lista_arquivos = Object.values(response.data);
        setListaArquivos(lista_arquivos);
      }).catch(() => {
        Swal.fire({
          title: 'Ooops...', 
          text: 'Ocorreu um erro ao carregar os dados do chamado.', 
          icon: 'error',
          confirmButtonText: `Recarregar`
        }).then((result) => {
          if(result.isConfirmed) {
            setRecarregarDadosChamado(!recarregarDadosChamado)
          }
        })
      })
    );
  }
  async function montaArquivo(event) {
    if (ValidaTipoArquivo.verificaTipoArquivo(event)) {
      let dadosArquivo = await convertFilesToBase64.convertFileToBase64(event);
      setArquivo(dadosArquivo);
    } else {
      errorToast.fire({
        text: "Tipo de arquivo não suportado, selecione outro ou verifique o mesmo",
      });
    }
  };

  function montaListaResponsaveis(usuarios, departamentos) {
    let departamentosAr = [];
    let responsaveis = [];
    departamentos.forEach((item) => {
      departamentosAr.push({
        value: "dep-" + item.id_departamento,
        label: "Departamento: " + item.nome,
      });
    });
    usuarios.forEach((item) => {
      responsaveis.push({ value: item.id, label: item.nome });
    });
    const concat = departamentosAr.concat(responsaveis);
    setListaResponsaveis(concat);
  }
  function montaListaTags(tags) {
    let listaTags = [];
    tags.forEach((item) => {
      listaTags.push({ value: item.id_ticket_tags, label: item.nome });
    });
    setListaTags(listaTags);
  }

  function onChangeResponsavelExecucao(value) {
    verificaRegxDepart(value);
  }

  function onChangeResponsavelAutorizacao(value) {
    verificaRegxDepartAltor(value);
  }

  function onChangeResponsavelAprovacao(value) {
    verificaRegxDepartAprov(value);
  }

  function onChangeAcompanhamento(value) {
    verificaRegxDepartAcomp(value);
  }

  function onChangeTags(value) {
    let listaTagsChange = [];
    value.forEach((item) => {
      if (item["__isNew__"]) {
        let novoItem = {
          nome: item["value"],
        };
        ticketTags.store(novoItem).then(
          (response) => {
            const cadastro = response.data;
            listaTagsChange.push({
              value: cadastro.id_ticket_tags,
              label: cadastro.nome,
            });
            ticketTags.index().then((response) => {
              montaListaTags(response.data);
            });
          },
          (error) => {
            Swal.fire({
              titleText: "Ooops...",
              text: "Ocorreu um erro ao inserir tag: " + error,
              icon: "error",
            });
          }
        );
      } else {
        listaTagsChange.push({ value: item.value, label: item.label });
      }
    });
    setTags(listaTagsChange);
  }
  function verificaRegxDepart(responsavel) {
    let arrDep = [];
    let arrRes = [];
    if (responsavel) {
      responsavel.map((item) => {
        if (item.label.match(/(Departamento: +[a-zA-Z0-9_.+-])/gm)) {
          arrDep.push({
            value: parseInt(item.value.split("-")[1]),
            label: item.label,
          });
        } else {
          arrRes.push(item);
        }
      });
    } else {
      return null;
    }
    setDepartamentosExecucao(arrDep);
    setResponsavelExecucao(arrRes);
  }

  function verificaRegxDepartAprov(responsavel) {
    let arrDep = [];
    let arrRes = [];
    if (responsavel) {
      responsavel.map((item) => {
        if (item.label.match(/(Departamento: +[a-zA-Z0-9_.+-])/gm)) {
          arrDep.push({
            value: item.value.split("-")[1],
            label: item.label,
          });
        } else {
          arrRes.push(item);
        }
      });
    } else {
      return null;
    }
    setDepartamentoAprovacao(arrDep);
    setResponsavelAprovacao(arrRes);
  }

  function verificaDefaultValueExec(responsavel, departamento) {
    let arrDefault = [];
    if (
      responsavel != null &&
      responsavel.length > 0 &&
      helper.isJson(responsavel)
    ) {
      JSON.parse(responsavel).map((item) => {
        arrDefault.push(item);
      });
    } 

    if (
      departamento != null &&
      departamento.length > 0 &&
      helper.isJson(departamento)
    ) {
      JSON.parse(departamento).map((item) => {
        arrDefault.push(item);
      });
    } 

    return arrDefault;
  }

  function verificaRegxDepartAcomp(responsavel) {
    let arrDep = [];
    let arrRes = [];
    if (responsavel) {
      responsavel.map((item) => {
        if (item.label.match(/(Departamento: +[a-zA-Z0-9_.+-])/gm)) {
          arrDep.push({
            value: item.value.split("-")[1],
            label: item.label,
          });
        } else {
          arrRes.push(item);
        }
      });
    } else {
      return null;
    }
    setDepartamentoAcompanhamento(arrDep);
    setAcompanhamento(arrRes);
  }

  function verificaRegxDepartAltor(responsavel) {
    let arrDep = [];
    let arrRes = [];
    if (responsavel) {
      responsavel.map((item) => {
        if (item.label.match(/(Departamento: +[a-zA-Z0-9_.+-])/gm)) {
          arrDep.push({
            value: item.value.split("-")[1],
            label: item.label,
          });
        } else {
          arrRes.push(item);
        }
      });
    } else {
      return null;
    }
    setDepartamentoAutorizacao(arrDep);
    setResponsavelAutorizacao(arrRes);
  }

  function mensagemAlteracaoChamado(mensagem){
    Swal.fire({
      titleText: 'Dados do ticket alterados',
      html: mensagem,
      icon: "warning",
      showCloseButton: false,
      showCancelButton: true,
      showDenyButton: false,
      focusConfirm: false,
      confirmButtonText: "Continuar!",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-primary mr-3",
        cancelButton: "btn btn-secondary mr-3",
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        atualizaChamado();
      }else{
        return;
      }
    })
  }

  function atualizaChamado() {
    let dados = {
      id_ticket_status: situacao,
      assunto: assunto,
      descricao: descricao,
      id_ticket_tipo: tipo,
      id_processo: Number(processo || ""),
      id_ticket_categoria: categoria,
      id_ticket_motivo: motivo,
      id_ticket_prioridade: prioridade,
      id_modulo: modulo,
      departamentos_execucao: departamentosExecucao,
      departamentos_autorizacao: departamentoAutorizacao,
      departamentos_aprovacao: departamentoAprovacao,
      departamentos_acompanhamento: departamentoAcompanhamento,
      responsaveis_execucao: responsavelExecucao,
      responsaveis_autorizacao: responsavelAutorizacao,
      responsaveis_aprovacao: responsavelAprovacao,
      usuarios_acompanhamento: acompanhamento,
      origem_ticket: meioComunicacao,
      tags: tags,
      dados_arquivo: arquivo,
      id_ticket_substatus: subSituacao,
      campos_dinamicos_respostas: camposDinamicosRespostas,
    };

    if(contextoChamados.permissoesTicket?.permitir_editar_data_limite && (dataLimite !== (chamado?.prazo_sla ?? ""))){
      dados.prazo_sla = dataLimite;
    }

    if(!categoria){
      Swal.fire({
        titleText: "Ooops...",
        text: "Campo de CATEGORIA não foi selecionado",
        icon: "warning",
      });
      return;
    }else if(!tipo){
      Swal.fire({
        titleText: "Ooops...",
        text: "Campo de TIPO não foi selecionado",
        icon: "warning",
      });
      return;
    }else if(!motivo){
      Swal.fire({
        titleText: "Ooops...",
        text: "Campo de TIPO não foi selecionado",
        icon: "warning",
      });
      return;
    }


    setDadosConclusao(dados);
    if (dados.id_ticket_status == "5" && chamado.status.id_ticket_status != 5) {
      setModalConclusao(true);
    } else {

      if(processoBusca !== "" && Number(processoBusca) !== chamado?.id_processo && dadosEmpreendimento){
        if (primeiroProponente !== null && primeiroProponente !== "") {
          Swal.fire({
            titleText: `Alterar`,
            text: `Você deseja alterar o chamado ${helper.zeroPad(
              chamado.id_ticket,
              7
            )} para o processo ${processoBusca}?`,
            icon: "question",
            showCloseButton: false,
            showCancelButton: true,
            showDenyButton: true,
            focusConfirm: false,
            confirmButtonText: "Sim!",
            denyButtonText: "Não.",
            cancelButtonText: "Cancelar",
            customClass: {
              confirmButton: "btn btn-primary mr-3",
              cancelButton: "btn btn-secondary mr-3",
              denyButton: "btn btn-danger mr-3",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.isConfirmed) {     
              dados.id_processo = processoBusca;
              dados.dados_empreendimento = dadosEmpreendimento;
              trackPromise(
                ticketService.update(chamado.id_ticket, dados).then(
                  (response) => {            
                    Swal.fire({
                      titleText: "Chamado atualizado",
                      text: "Chamado atualizado com sucesso!",
                      icon: "success",
                    }).then(() => {          
                        window.location.reload();
                    });
                  },
                  (error) => {
                    Swal.fire({
                      titleText: "Ooops...",
                      text: "Ocorreu um erro ao salvar o chamado: " + error,
                      icon: "error",
                    });
                  }
                )
              );
            } else if (result.isDenied) {
              return;
            } else {
              return;
            }
          });
        }
      }else{
        trackPromise(
          ticketService.update(chamado.id_ticket, dados).then(
            (response) => {            
              Swal.fire({
                titleText: "Chamado atualizado",
                text: "Chamado atualizado com sucesso!",
                icon: "success",
              }).then(() => {          
                if(response?.data?.responsaveis_autorizacao){
                  setResponsavelAutorizacao(response?.data?.responsaveis_autorizacao);
                }
                if(response?.data?.resposaveis_aprovacao){
                  setResponsavelAprovacao(response?.data?.resposaveis_aprovacao);
                }
                if(response?.data?.responsaveis_execucao){
                  setResponsavelExecucao(response?.data?.responsaveis_execucao);
                }
                if(response?.data?.usuarios_acompanhamento){
                  setAcompanhamento(response?.data?.usuarios_acompanhamento); 
                }
                setPrimeiroProponente(response?.data?.proponentes?.proponente1_nome ?? ""); 
                setEmpreendimentoNome(response?.data?.nome_empreendimento ?? "")
                atualizarChamado(response?.data);
                buscarStatusTicket();
              });
            },
            (error) => {
              Swal.fire({
                titleText: "Ooops...",
                text: "Ocorreu um erro ao salvar o chamado: " + error,
                icon: "error",
              });
            }
          )
        );
      }      
    }
  }

  function atualizarChamado(newChamado){
    setArquivo([]);
    buscarArquivos();
    setChamado(newChamado);
    setRefresh((current)=>!current);
    if(habilitarEdicaoChamado){
      setHabilitarEdicaoChamado(false);
    }
    if(habilitarEdicaoQualificacao){
      setHabilitarEdicaoQualificacao(false);
    }
    if(habilitarEdicaoCamposDinamicos){
      setHabilitarEdicaoCamposDinamicos(false);
    }
  }

  function NotaInterna() {

    const alterarEtapaStatus = guService.getLocalState("config_alterar_status");

    if ( alterarEtapaStatus === "1" && statusMudou )
    {
        Swal.fire
        ({
            title: 'Preencha a Nota Abaixo',
            icon: 'info',
            confirmButtonText: 'Ok ',
            showCloseButton: true,
            customClass: {
              confirmButton: 'btn btn-primary mr-3',
            },
            buttonsStyling: false
        })
        .then((result) => {
          if ( result.isConfirmed ) 
          {
            setModalNotaInterna(true);
          }
        })
    }
    else 
    {
      const alteracaoMotivo = Number(motivo) !== Number(chamado?.motivo?.id_ticket_motivo);
      const alteracaoTipo = (Number(tipo) !== Number(chamado?.tipo?.id_ticket_tipo)) && chamado?.fluxo_etapa;
      if(alteracaoMotivo || alteracaoTipo){
        let mensagem = "";
        if(alteracaoTipo){
          mensagem += "<p>O <b>FLUXO DE ATENDIMENTO</b> foi alterado. Fluxo de etapas atual e os valores de campos dinâmicos serão perdidos! E o ticket será evoluido para primeira etapa do novo fluxo de etapas.</p>";
        }
        if(alteracaoMotivo){
          mensagem += "<p>O <b>MOTIVO</b> do ticket foi alterado. Com isso, os responsáveis e o prazo SLA do ticket também serão alterados.</p>";
        }
        mensagem += "<p>Deseja prosseguir??</p>";
        mensagemAlteracaoChamado(mensagem);
      }else{
        atualizaChamado();
      }
    }
  }

  function deletarArquivo(id) {
    trackPromise(
      ticketService.deletarArquivos(id).then(
        (res) => {
          Swal.fire({
            titleText: "Excluído!",
            text: "Arquivo excluído com sucesso.",
            icon: "success",
          }).then(() => {
            close();
          });
        },
        (error) => {
          Swal.fire({
            titleText: "Ooops...",
            text: "Ocorreu um erro ao excluír o arquivo: " + error,
            icon: "error",
          });
        }
      )
    );
  }

  function handleBuscaProcesso() {
    ProcessoService.buscarDadosProcesso(processoBusca).then((res) => {
      if (res.data.proponente1_nome != null) {
        setEmpreendimentoNome(`${res?.data?.empreendimento_nome} - ${res?.data?.unidade_descricao ?? "Não encontrado"}`);
        setPrimeiroProponente(res?.data?.proponente1_nome);
        setDadosEmpreendimento({
          "id_empreendimento": res?.data?.processo_empreendimento,
          "descricao_unidade": res?.data?.unidade_descricao,
          "nome_empreendimento": res?.data?.empreendimento_nome
          }
        );
      }else{
        Swal.fire({
          titleText: "Ooops...",
          text: "Processo não encotrado!",
          icon: "error",
        });
      }
    });
  }

  const buscarNomeStatus = useCallback((situacao)=>{
    if(contextoChamados.listaStatus.length){
      let status = contextoChamados.listaStatus?.find((item)=>{
        return item?.id_ticket_status?.toString() === situacao?.toString()
      })
      if(status){
        return status?.nome;
      }else{
        status = contextoChamados.listaStatus.find((item)=>{
          return item?.id_ticket_status === 6
        })
        if(status){
          return status?.nome;
        }else{
          return " --- ";
        }
      }
    }else{
      return " --- ";
    }
  }, [contextoChamados.listaStatus, chamado])

  const buscarNomeSubStatus = useCallback((situacao)=>{
    let status = listaSubStatus.find((item)=>{
      return item?.id_ticket_substatus?.toString() === situacao?.toString()
    })
    if(status){
      return status?.nome;
    }else{
      return " --- ";        
    }
  },[listaSubStatus, chamado]);

  const buscarNomeTipo = useCallback((tipo)=>{
    let tipoEncontrado = listaTipos.find((item)=>{
      return item?.id_ticket_tipo?.toString() === tipo?.toString()
    })
    if(tipoEncontrado){
      return tipoEncontrado?.nome;
    }else{
      return " --- ";        
    }
  },[listaTipos, chamado]);

  const buscarNomeCategoria = useCallback((categoria)=>{
    let encontrado = listaCategorias.find((item)=>{
      return item?.id_ticket_categoria?.toString() === categoria?.toString()
    })
    if(encontrado){
      return encontrado?.nome;
    }else{
      return " --- ";        
    }
  },[listaCategorias, chamado]);

  const buscarNomeMotivo = useCallback((motivo)=>{
    let encontrado = listaMotivos.find((item)=>{
      return item?.id_ticket_motivo?.toString() === motivo?.toString()
    })
    if(encontrado){
      return encontrado?.nome;
    }else{
      return " --- ";        
    }
  },[listaMotivos, , chamado]);

  const buscarNomePrioridade = useCallback((prioridade)=>{
    let encontrado = listaPrioridades.find((item)=>{
      return item?.id_ticket_prioridade?.toString() === prioridade?.toString()
    })
    if(encontrado){
      return encontrado?.nome;
    }else{
      return " --- ";        
    }
  },[listaMeioComunicacao, , chamado]);

  const resolverTags = useCallback((tags)=>{
    return tags != null
            ? tags.length > 0
              ? helper.isJson(tags)
                ? JSON.parse(tags)
                : tags
              : []
            : []

  },[]);

  const arquivosThumb = useMemo(() =>{
    return (
      listaArquivos.map((arquivo, index) => arquivo.nome_arquivo && (<OverlayTrigger key={index} overlay={<Tooltip>{arquivo.nome_arquivo}</Tooltip>}>
        <div>
          <DommusThumbnail url={arquivo.link} arquivo={arquivo} />
        </div>
      </OverlayTrigger>) || (<DommusThumbnail url={arquivo.link}/>))      
    )
  },[listaArquivos, chamado]);

  const camposChamadoEdicao = ()=>{
    return (
      <Form>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Processo:</div>
              <InputGroup className="mb-3">
                <Form.Control
                  aria-label="Processos"
                  name="opv"
                  defaultValue={processo}
                  onChange={(event) => {
                    setProcessoBusca(event.target.value);
                    setDadosEmpreendimento(null);
                    setPrimeiroProponente(null)
                    setEmpreendimentoNome(null);
                  }}
                  disabled={disabled}
                />
                {(chamado.id_usuario_solicitante == guService.getLocalState("idUsuario")) &&
                  <InputGroup.Append>
                    <a
                      style={{cursor: "pointer"}}
                      onClick={() => {
                        if (disabled) {
                          setDisabled(false);
                        } else {
                          if(processoBusca !== ""){
                            handleBuscaProcesso();
                          }
                        }
                      }}
                    >
                      {disabled ? 
                        <Icon
                          icon={editFilled}
                          color="var(--dommus-color)"
                          width="1.5rem"
                          height="1.5rem"
                        />
                        :
                        <Icon
                          icon={searchOutlined}
                          color="var(--dommus-color)"
                          width="1.5rem"
                          height="1.5rem"
                        />
                      }
                    </a>
                  </InputGroup.Append>
                }
              </InputGroup>
            </Form.Group>
          </Col>    
          <Col>
            <Form.Group>
              <div className="inputLabel">Origem:</div>
              <Form.Control
                as="select"
                className="selectMotivo"
                value={meioComunicacao ?? "selecionar"}
                name="motivo"
                onChange={(event) => {
                  setMeioComunicacao(event.target.value);
                }}
              >
                <option value="selecionar"> Selecionar </option>
                <option value="cadastro_manual">CADASTRO MANUAL</option>
                {listaMeioComunicacao && listaMeioComunicacao.length && listaMeioComunicacao.map((value, index) => (
                  <option
                    key={index}
                    value={value.slug}
                  >
                    {value.slug.toUpperCase()}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>              
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Empreendimento\Unidade:</div>
                <Form.Control
                  aria-label="Solicitante"
                  name="solicitante"
                  value={empreendimentoNome ?? "Não atribuido"}
                  onChange={() => {}}
                  disabled
                />
            </Form.Group>
          </Col> 
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">1º Proponente:</div>
                <Form.Control
                  aria-label="Solicitante"
                  name="solicitante"
                  value={primeiroProponente?.nome ?? " --- "}
                  onChange={() => {}}
                  disabled
                />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Solicitante:</div>
                <Form.Control
                  aria-label="Solicitante"
                  name="solicitante"
                  value={solicitante === null ? "" : solicitante?.nome}
                  onChange={() => {}}
                  disabled
                />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <div className="inputLabel">Data do abetura:</div>
              <Form.Control
                className="dataChamado"
                type="datetime"
                id="date-input"
                name="data_cadastro"
                disabled={true}
                value={
                  dataCadastro === null
                    ? ""
                    : format(parseISO(dataCadastro), "dd/MM/yyyy' às ' HH:mm")
                }
                onChange={() => {}}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
                <div className="inputLabel">Etapa:<DommusRequiredSpan/></div>
              {!habilitarReabrirChamado && 
                <ReactTooltip id="situacao-tooltip" place="top" type="dark" effect="solid">
                  Fora do período de reabertura do chamados
                </ReactTooltip>              
              }
              <Form.Control
                data-tip data-for="situacao-tooltip"
                as="select"
                className="selectSituacao"
                value={situacao === null ? "6" : situacao}
                name="situacao"
                onChange={(event) => {
                  setSituacao(event.target.value);
                  setSubSituacao(null);
                  setStatusMudou(true);
                }}
                disabled={!habilitarReabrirChamado}
              >
                {contextoChamados.listaStatus.filter((item)=>!item.concluido_em || item.id_ticket_status === Number(chamado?.status?.id_ticket_status)).map((value, index) => (
                  <option
                    key={index}
                    value={value.id_ticket_status}
                    disabled={value?.habilitado_evolucao === false || value?.etapa_futura === true}
                  >
                    {value.nome}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <div className="inputLabel">Status:</div>
              <Form.Control
                as="select"
                className="selectSubSituacao"
                value={subSituacao == null ? "" : subSituacao}
                name="subSituacao"
                disabled={!habilitarReabrirChamado}
                onChange={(event) => {
                  setSubSituacao(event.target.value);
                }}
              >
                <option value="selecionar">Selecionar </option>
                {listaSubStatus.filter((item)=> !item.concluido_em || item.id_ticket_substatus === Number(chamado.id_ticket_substatus)).map((value, index) => (
                  <option 
                    key={index} 
                    value={value.id_ticket_substatus}
                    disabled={value?.habilitado_evolucao === false || value?.status_futura === true}
                  >
                    {value.nome}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Assunto:</div>
              <Form.Control
                as="textarea"
                rows={3}
                name="assunto"
                disabled={true}
                value={assunto === null ? "" : assunto}
                onChange={() => {}}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Descrição</div>
              <Form.Control
                as="textarea"
                rows={3}
                name="descricao"
                disabled={true}
                value={descricao === null ? "" : descricao}
                onChange={() => {}}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Fluxo de Atendimento <DommusRequiredSpan/></div>
              <Form.Control
                as="select"
                className="selectTipo"
                value={tipo === null ? "selecionar" : tipo}
                name="tipo"
                onChange={(event) => {
                  setTipo(event.target.value);
                  setCategoria("");
                  setMotivo("");
                }}
              >
                <option value="selecionar"> Selecionar </option>
                {listaTipos.map((value, index) => (
                  <option
                    key={index}
                    value={value.id_ticket_tipo}
                  >
                    {value.nome}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        {usaModuloTicket && (
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Módulo<DommusRequiredSpan/></div>
              <Form.Control
                as="select"
                className="selectModulo"
                value={modulo === null ? "selecionar" : modulo}
                name="modulo"
                onChange={(event) => {
                  setMotivo("");
                  setCategoria("");
                  setModulo(event.target.value);
                }}
              >
                <option value="selecionar"> Selecionar </option>
                {listaModulos.map((value, index) => (
                  <option
                    key={index}
                    value={value.id}
                  >
                    {value.nome}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        )}
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Categoria<DommusRequiredSpan/></div>
              <Form.Control
                as="select"
                className="selectCategoria"
                value={categoria === null ? "selecionar" : categoria}
                name="categoria"
                onChange={(event) => {
                  setMotivo("");
                  setCategoria(event.target.value);                  
                }}
              >
                <option value="selecionar"> Selecionar </option>
                {listaCategorias.filter((item) => modulo === "" || item.id_modulo === Number(modulo)).map((value, index) => (
                  <option
                    key={index}
                    value={value.id_ticket_categoria}
                  >
                    {value.nome}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Motivo <DommusRequiredSpan/></div>
              <Form.Control
                as="select"
                className="selectMotivo"
                value={motivo === null ? "selecionar" : motivo}
                name="motivo"
                onChange={(event) => {
                  setMotivo(event.target.value);      
                  let motivoSelecionado = listaMotivos.find((motivo) => motivo.id_ticket_motivo === Number(event.target.value));
                  if(motivoSelecionado){
                    setCategoria(motivoSelecionado?.id_ticket_categoria ?? categoria);
                    setTipo(motivoSelecionado?.id_ticket_tipo ?? tipo);
                    setPrioridade(motivoSelecionado?.id_ticket_prioridade ?? prioridade)
                  }
                }}
              >
                <option value="selecionar"> Selecionar </option>
                {listaMotivos.filter((item) => categoria === "" || item.id_ticket_categoria === Number(categoria)).map((value, index) => (
                  <option
                    key={index}
                    value={value.id_ticket_motivo}
                  >
                    {value.nome}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>  
          </Col>
        </Row>    
        <Row>
          <Col>
            <Form.Group>
              <DommusToggle
                title={`Arquivos (Total: ${listaArquivos.length})`}
                toggle={listaArquivos.length > 0 ? true : false}
              >
                <ul className="list-unstyled">
                  {listaArquivos.map((url, i) => (
                    <Media
                      key={i}
                      as="li"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderBottom: "1px solid #ddd",
                        marginBottom: 5,
                      }}
                    >
                      <Icon
                        icon={pageDoc}
                        color="var(--dommus-color)"
                        width="1.1rem"
                        height="1.1rem"
                      />
                      <Media.Body>
                        <a
                          onClick={() => {
                            if (url.link.match(/https/gi)) {
                              urlHelper.download(url.link);
                            } else {
                              var newstr = url.link.replace(
                                /http/gi,
                                "https"
                              );
                              urlHelper.download(newstr);
                            }
                          }}
                        >
                          <Form.Label
                            style={{ marginBottom: 0, cursor: "pointer" }}
                          >
                            Documento {i}
                          </Form.Label>
                        </a>
                      </Media.Body>
                      <FontAwesomeIcon
                        onClick={() => deletarArquivo(url.id_ticket_arquivo)}
                        icon={faTrash}
                        style={{
                          color: "red",
                          cursor: "pointer",
                          marginLeft: 5,
                        }}
                      />
                    </Media>
                  ))}
                </ul>
              </DommusToggle>
            </Form.Group>
          </Col>
        </Row> 
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Enviar arquivos</div>
              <Form.Control
                className="form-control-file"
                id="file"
                name="file"
                accept="application/pdf, image/jpg, image/png, image/jpeg"
                type="file"
                onChange={(e) => {montaArquivo(e.target.files)}}
                multiple
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    )
  }

  const chamadoInfo = ()=>{
    return (
      <div className="informacoes">
        <Row>
          <Col xs={10} sm={10} lg={10} >
            <div className="item-info">
              <label>{chamado?.tipo_chamado == 'U' && 'Cliente' || 'Empreendimento'}:</label>
              <span onClick={()=>{
                  if(chamado?.tipo_chamado == 'U' && chamado?.id_processo ) {
                    window.open(guService.getLocalState("linkVendas") +  "index_ui.php?mgr=MQ==&ui=NjM=&id_processo="  + chamado?.id_processo);
                  }
                }}
                className="processo-link"
              >
                <span>{chamado.tipo_chamado === 'U' ?
                  (chamado?.id_processo ? `#${chamado?.id_processo.toString().padStart(5, '0')}` : "Processo não vinculado")
                :chamado?.tipo_chamado === 'SR' && !chamado?.id_processo ? "Processo não vinculado" : chamado?.id_processo ? `#${chamado?.id_processo?.toString()?.padStart(5, '0')}` : 'Área Comum'}</span> 
                {chamado?.dados_empreendimento?.descricao_unidade && 
                  <span>&nbsp;|&nbsp;{chamado?.dados_empreendimento?.descricao_unidade}</span>
                }
                {chamado?.dados_empreendimento?.nome_empreendimento &&
                  <span>{`${chamado?.tipo_chamado == 'U' && chamado?.id_processo && ' | ' || ''} ${chamado?.dados_empreendimento?.nome_empreendimento}`}</span>
                }
                {chamado?.proponentes?.proponente1 ?
                  <span>&nbsp;|&nbsp;{`${chamado?.proponentes?.proponente1} ${chamado?.proponentes?.proponente1_cpf ? `(${handleFormataDocumentoProponente(chamado?.proponentes?.proponente1_cpf)})` : ''}`}</span>
                  : <span>&nbsp;|&nbsp;{`${chamado?.dados_empreendimento?.nome_proponente} ${chamado?.dados_empreendimento?.cpf_proponente ? `(${handleFormataDocumentoProponente(chamado?.dados_empreendimento?.cpf_proponente)})` : ''}`}</span>
                }
                {chamado?.codigo_relacionamento && mostrarCodigoRelacionamento ?  
                  <span> - CR: ({chamado?.codigo_relacionamento})</span>
                  : <></>
                }
              </span>        
            </div>
          </Col>                   
          <Col xs={2} sm={2} lg={2} >
            {chamado?.origem_ticket && 
              <MeioComunicacaoIcone midia={chamado?.origem_ticket} tooltipPrefix="Origem do chamado: " className={"icone-midia"} />
            }
          </Col> 
        </Row>        
        <Row className="row-gap">
          <Col xs={12} sm={12} lg={6} xl={6}>
            <div className="item-info">
              <label>Solicitante:</label>
              <span>{chamado?.solicitante?.nome ?? ""}</span>        
            </div>
          </Col>
          <Col xs={12} sm={12} lg={6} xl={6}>
            <div className="item-info">
              <label>Data de Abertura:</label>
              <span>{ chamado?.criado_em == null
                        ? ""
                        : format(parseISO(chamado?.criado_em), "dd/MM/yyyy' às ' HH:mm")
                    }
              </span>        
            </div>
          </Col>
        </Row>
        <Row className="row-gap">
          <Col xs={12} sm={12} lg={6} xl={6}>
            <div className="item-info">
              <label>Etapa:</label>
              <span>{buscarNomeStatus(chamado?.status?.id_ticket_status)}</span>        
            </div>
          </Col>
          <Col xs={12} sm={12} lg={6} xl={6}>
            <div className="item-info">
              <label>Status:</label>
              <span>{buscarNomeSubStatus(chamado?.substatus?.id_ticket_substatus)}</span>        
            </div>
          </Col>
        </Row>      
        <Row className="row-gap">
          <Col xs={12} sm={12} lg={6} xl={6}>
            <div className="item-info">
              <label>Fluxo de Atendimento:</label>
              <span>{buscarNomeTipo(chamado?.tipo?.id_ticket_tipo)}</span>        
            </div>
          </Col>
          <Col xs={12} sm={12} lg={6} xl={6}>
            <div className="item-info">
              <label>Categoria:</label>
              <span>{buscarNomeCategoria(chamado?.categoria?.id_ticket_categoria)}</span>        
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="item-info">
              <label>Motivo:</label>
              <span>{buscarNomeMotivo(chamado?.motivo?.id_ticket_motivo)}</span>        
            </div>
          </Col>
        </Row>       
        <Row>
          <Col>
            <div className="item-info">
              <label>Assunto:</label>
              <span>{chamado?.assunto ?? " --- "}</span>        
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="item-info">
              <label>Descrição:</label>
              <span>{chamado?.descricao ?? " --- "}</span>        
            </div>
          </Col>
        </Row>
        <Row>
          <Col>          
            <div className="item-info">
              <label className="mb-2">Anexos:</label>
              <div className="files-section">
                {arquivosThumb}
              </div>             
            </div>
          </Col>
        </Row>
      </div>
    );
  }


  const camposQualificacaoEdicao = ()=>{
    return (
      <Form>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Prioridade</div>
              <Form.Control
                as="select"
                className="selectPrioridade"
                value={prioridade === null ? "selecionar" : prioridade}
                name="prioridade"
                onChange={(event) => {
                  setPrioridade(event.target.value);
                }}
              >
                <option value="selecionar"> Selecionar </option>
                {listaPrioridades.map((value) => (
                  <option
                    key={value.id_ticket_prioridade}
                    value={value.id_ticket_prioridade}
                  >
                    {value.nome}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <div className="inputLabel">Data Limite</div>
              <Form.Control
                className="dataLimite"
                type={contextoChamados.permissoesTicket?.permitir_editar_data_limite? "datetime-local" : "text"}
                id="date-input"
                name="dataLimite"
                readOnly={!contextoChamados.permissoesTicket?.permitir_editar_data_limite}
                value={
                  dataLimite
                    ? contextoChamados.permissoesTicket?.permitir_editar_data_limite ? dataLimite : format(parseISO(dataLimite), "dd/MM/yyyy' às 'HH:mm")
                    : "dd/mm/yyyy"
                }
                onChange={(event) => {
                  if(contextoChamados.permissoesTicket?.permitir_editar_data_limite){
                    setDataLimite(moment(event.target.value).format("YYYY-MM-DD HH:mm:ss"));
                  }
                }}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Responsável Autorização:</div>
              <Select
                isMulti
                options={listaResponsaveis}
                defaultValue={verificaDefaultValueExec(
                  responsavelAutorizacao,
                  departamentoAutorizacao
                )}
                className="basic-multi-select"
                placeholder="Selecione"
                menuPlacement="top"
                onChange={onChangeResponsavelAutorizacao}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Responsável Execução: </div>
              <Select
                isMulti
                placeholder="Selecione"
                options={listaResponsaveis}
                defaultValue={verificaDefaultValueExec(
                  responsavelExecucao,
                  departamentosExecucao
                )}
                className="basic-multi-select"
                menuPlacement="top"
                onChange={onChangeResponsavelExecucao}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Responsável Aprovação:</div>
              <Select
                isMulti
                defaultValue={verificaDefaultValueExec(
                  responsavelAprovacao,
                  departamentoAprovacao
                )}
                options={listaResponsaveis}
                className="basic-multi-select"
                placeholder="Selecione"
                menuPlacement="top"
                onChange={onChangeResponsavelAprovacao}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Acompanhamento/Seguidores: </div>
              <Select
                isMulti
                defaultValue={verificaDefaultValueExec(
                  acompanhamento,
                  departamentoAcompanhamento
                )}
                options={listaResponsaveis}
                className="basic-multi-select"
                placeholder="Selecione"
                menuPlacement="top"
                onChange={onChangeAcompanhamento}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group>
              <div className="inputLabel">Tags</div>
              {
                <CreatableSelect
                  defaultValue={
                    tags != null
                      ? tags.length > 0
                        ? helper.isJson(tags)
                          ? JSON.parse(tags)
                          : tags
                        : []
                      : []
                  }
                  isMulti
                  menuPlacement="top"
                  options={listaTags}
                  className="basic-multi-select"
                  placeholder="Selecione"
                  onChange={(event) => onChangeTags(event)}
                />
              }
            </Form.Group>
          </Col>
        </Row>        
      </Form>
    );
  }

  const qualificacaoInfo = ()=>{
    return (
      <div className="informacoes">
        {String(guService.getLocalState("idInquilino")) === "10" && (
          <>
            <Row>
              <Col>
                <div className="item-info">
                  <label>Módulo:</label>
                  <span>{listaModulos.find((item) => Number(item.id) === Number(chamado?.categoria?.id_modulo))?.nome ?? "Não Atribuído"}</span>
                </div>
              </Col>
            </Row>
            <hr/>
          </>
        )}
        <Row>
          <Col xs={6} lg={6} >
            <div className="item-info">
              <label>Prioridade:</label>
              <span style={{display: "flex", gap: "10px", alignItems: "center"}}>{buscarNomePrioridade(chamado?.prioridade?.id_ticket_prioridade)} <IconePrioridade prioridade={buscarNomePrioridade(chamado?.prioridade?.id_ticket_prioridade)}/></span>        
            </div>
          </Col>
          <Col xs={6} lg={6}>

            <div className="item-info">
              <label>Data Limite:</label>
              <span>{ chamado?.prazo_sla
                      ? format(parseISO(chamado?.prazo_sla ?? ""), "dd/MM/yyyy' às 'HH:mm")
                      : "dd/mm/yyyy"
                    }
              </span>        
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="item-info">
              <label>Resposáveis Autorização:</label>              
                <DommusBadgesResposaveis items={verificaDefaultValueExec(
                                                chamado?.responsaveis_autorizacao ?? [],
                                                chamado.departamentos_autorizacao ?? []
                                          )}                   
                />                    
            </div>
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col>
            <div className="item-info">
              <label>Resposáveis Execução:</label>
              <DommusBadgesResposaveis items={ verificaDefaultValueExec(
                                                chamado.responsaveis_execucao || [],
                                                chamado.departamentos_execucao || []
                                              )}
              />
            </div>
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col>
            <div className="item-info">
              <label>Resposáveis Aprovação:</label>
              <DommusBadgesResposaveis items={verificaDefaultValueExec(
                                          chamado.responsaveis_aprovacao || [],
                                          chamado.departamentos_aprovacao || []
                                        )}    
              />        
            </div>
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col>
            <div className="item-info">
              <label>Acompanhamento/Seguidores:</label>
              <DommusBadgesResposaveis items={verificaDefaultValueExec(
                                                chamado.usuarios_acompanhamento || [],
                                                chamado.departamentos_acompanhamento || []
                                              )}
              />        
            </div>
          </Col>
        </Row>
        <hr/>
        <Row>
          <Col>
            <div className="item-info">
              <label>Tags:</label>
              <DommusBadgesResposaveis items={ resolverTags(chamado?.tags || []) }/>        
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  const handleResolverCampoDinamico = (campo)=>{
    switch(campo?.id_tipo_campo_dinamico){
      case EnumTipoCampoDinamico.MULTIPLA_SELECAO:
        return(
          <Select
            isMulti
            options={campo.options}
            className="basic-multi-select"
            placeholder="Selecione"
            value={camposDinamicosRespostas[`campo_${campo.id_campo_dinamico}`]}
            onChange={(event)=>{
                const resposta = {
                  [`campo_${campo.id_campo_dinamico}`]: event
                }
                setCamposDinamicosRespostas((current) => {return {...current, ...resposta}});
            }}
          />
        )
      case EnumTipoCampoDinamico.SIMPLES_SELECAO:
        return(
          <Form.Control
              as="select"
              className="selectPrioridade"
              value={camposDinamicosRespostas[`campo_${campo.id_campo_dinamico}`]}
              onChange={(event) => {
                const resposta = {
                  [`campo_${campo.id_campo_dinamico}`]: event.target.value
                }
                setCamposDinamicosRespostas((current) => {return {...current, ...resposta}});
              }}
          >
            <option value="" hidden> Selecionar </option>
            {campo?.options.map((item, index) => (
              <option
                key={index}
                value={item.value}
              >
                {item.label}
              </option>
            ))}
          </Form.Control>
        );
      case EnumTipoCampoDinamico.CHECKBOX:
        return(
          <div className="campo-dinamico-checkbox-section">
            {campo?.options?.map((item, index)=>{
              return (
                <Form.Group  key={index} controlId={`campo_check_${index}`}>
                  <Form.Check 
                    inline 
                    type="checkbox" 
                    label={item.label} 
                    value={item.value} 
                    checked={camposDinamicosRespostas[`campo_${campo.id_campo_dinamico}`] ? camposDinamicosRespostas[`campo_${campo.id_campo_dinamico}`][item.value] ?? false : false}
                    onChange={((event)=>{
                       const resposta = {
                         [item.value]: event.target?.checked, 
                       }
                       setCamposDinamicosRespostas((current) => {
                          current[`campo_${campo.id_campo_dinamico}`] = {...current[`campo_${campo.id_campo_dinamico}`], ...resposta}
                          return {...current}
                       });
                    })}
                  />
                </Form.Group>
              )
            })}
          </div>
        )
      default:
        var formatador = null;
        var type = 'text';
        var placeholder = ""
        switch(campo?.id_tipo_campo_dinamico){
          case EnumTipoCampoDinamico.CEP:
            placeholder = "0000-000"
            type = 'text';
            formatador = cepMask;
            break;
          case EnumTipoCampoDinamico.CPF:
            placeholder = "000.000.000-00"
            type = 'text';
            formatador = cpfMask;
            break;
          case EnumTipoCampoDinamico.DATA:
            type = 'date';
            formatador = null;
            break;
          case EnumTipoCampoDinamico.TELEFONE:
            placeholder = "(00)00000-0000"
            type = 'text';
            formatador = celularMask;
            break;
          case EnumTipoCampoDinamico.MONETARIO:
            placeholder = "00,00"
            type = 'text';
            formatador = realMoeda;
            break;
          default:
            break;
        }
        return(
          <Form.Control
             type={type}
             className="selectPrioridade"
             value={camposDinamicosRespostas[`campo_${campo.id_campo_dinamico}`]}
             onChange={(event) => {
               var valor = event.target.value;
               if(formatador){
                 valor = formatador(valor);
               }
               const resposta = {
                 [`campo_${campo.id_campo_dinamico}`]: valor 
               }
               setCamposDinamicosRespostas((current) => {return {...current, ...resposta}});
             }}
          />
        )
    }
  }

  const camposDinamicosEdicao = ()=>{
    return (
      <Form>
        <Row>
          {chamado?.campos_dinamicos.sort((a, b) => {
             if(EnumTipoCampoDinamico.CHECKBOX === a.id_tipo_campo_dinamico) return 1;
             if(EnumTipoCampoDinamico.CHECKBOX === b.id_tipo_campo_dinamico) return -1;
             return a.label > b.label ? 1 : -1;
          }).map((item)=>{
            return (
              <Col lg={item.id_tipo_campo_dinamico === EnumTipoCampoDinamico.CHECKBOX ? 12 : 6} sm={12}>
                <Form.Group>
                  <div className="inputLabel">{item.label}</div>
                  {handleResolverCampoDinamico(item)}
                </Form.Group>
              </Col>
            )
          })}
        </Row>        
      </Form>
    );
  }
  
  const handleResolveRespostasArray = (idCampoDinamico) => {
    const keyName = `campo_${idCampoDinamico}`;
    if(Array.isArray(camposDinamicosRespostas[keyName])){
      return camposDinamicosRespostas[keyName].map((item) => item.label);
    }else if (camposDinamicosRespostas[keyName]){
      var itens = [];
      Object.keys(camposDinamicosRespostas[keyName]).forEach((key)=>{
        const campoDinamico = chamado.campos_dinamicos.find((item)=> item.id_campo_dinamico === idCampoDinamico);
        if(campoDinamico){
          campoDinamico.options.forEach((item)=>{
            if(camposDinamicosRespostas[keyName][key] && item?.value === key){
              itens.push(item.label);
            }
          })
        }
      })
      return itens;
    }
    return [];
  }

  const camposDinamicosInfo = ()=>{
    return (
      <div className="informacoes">
        <Row>
          {chamado?.campos_dinamicos?.sort((a, b) => {
             if([EnumTipoCampoDinamico.CHECKBOX, EnumTipoCampoDinamico.MULTIPLA_SELECAO].includes(a.id_tipo_campo_dinamico)) return 1;
             if([EnumTipoCampoDinamico.CHECKBOX, EnumTipoCampoDinamico.MULTIPLA_SELECAO].includes(b.id_tipo_campo_dinamico)) return -1;
             return a.label > b.label ? 1 : -1;
          }).map((item, index)=>{
            switch(item.id_tipo_campo_dinamico){
              case EnumTipoCampoDinamico.MULTIPLA_SELECAO:
              case EnumTipoCampoDinamico.CHECKBOX:
                return (
                    <Col key={index} sm={12} lg={12} className="mb-2">
                      <div className="item-info">
                        <label>{item.label}:</label>
                        <div className="badges-section-campos-dinamicos">
                          {handleResolveRespostasArray(item.id_campo_dinamico).map((item, index)=>{
                            return (
                              <Badge variant="secondary" key={index}>{item}</Badge>
                            )
                          })}
                        </div>      
                      </div>
                    </Col>
                )
              default:
                var resposta = camposDinamicosRespostas[`campo_${item.id_campo_dinamico}`];
                  switch(item.id_tipo_campo_dinamico){
                    case EnumTipoCampoDinamico.SIMPLES_SELECAO:
                      const campoDinamico = chamado.campos_dinamicos.find((current)=> current.id_campo_dinamico === item.id_campo_dinamico);
                      campoDinamico.options.forEach((item)=>{
                        if(item?.value === resposta){
                          resposta = item.label;
                        }
                      })
                      break;
                    case EnumTipoCampoDinamico.DATA:
                      resposta = resposta ? moment(resposta).format('DD/MM/YYYY') : "---";
                      break;
                    default:
                      break;
                  }
                return (
                  <Col xs={6} lg={6} key={index} className="mb-2">
                    <div className="item-info">
                      <label>{item.label}:</label>
                      <span style={{display: "flex", gap: "10px", alignItems: "center"}}>{resposta ?? "---"}</span>        
                    </div>
                  </Col>
                )
            }
          })}
        </Row>
      </div>
    )
  }

  const conclusaoInfo = ()=>{
    var url = chamado?.conclusao?.arquivo;
    return (
      <div className="informacoes">
      <Row>
        <Col xs={12} lg={12} >
          <div className="item-info">
            <label>Solução:</label>
            <span style={{display: "flex", gap: "10px", alignItems: "center"}}>
              {chamado?.conclusao?.id_ticket_conclusao_tipo?.nome}
            </span>        
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6} lg={6}>
          <div className="item-info">
            <label>Usuário Responsável:</label>
            <span>{ chamado?.conclusao?.usuario_responsavel ?? ""}
            </span>        
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className="item-info">
            <label>Data Conclusão:</label>
            <span>{ !!chamado?.conclusao?.data_conclusao?.length
                    ? format(parseISO(chamado?.conclusao?.data_conclusao ?? ""), "dd/MM/yyyy' às 'HH:mm")
                    : "dd/mm/yyyy"
                  }
            </span>        
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="item-info">
            <label>Resposta</label>              
              <span>
                {chamado?.conclusao?.descricao}
              </span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="item-info">
            <label>Arquivo:</label>
            {url ? 
              <Media
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #ddd",
                  marginBottom: 5,
                }}
              >
                <Icon
                  icon={pageDoc}
                  color="var(--dommus-color)"
                  width="1.1rem"
                  height="1.1rem"
                />
                <Media.Body>
                  <a
                    onClick={() => {
                      if (url.link.match(/https/gi)) {
                        urlHelper.download(url.link);
                      } else {
                        var newstr = url.link.replace(
                          /http/gi,
                          "https"
                        );
                        urlHelper.download(newstr);
                      }
                    }}
                  >
                    <Form.Label
                      style={{ marginBottom: 0, cursor: "pointer" }}
                    >
                      Documento
                    </Form.Label>
                  </a>
                </Media.Body>
                <FontAwesomeIcon
                  onClick={() => deletarArquivo(url.id_ticket_arquivo)}
                  icon={faTrash}
                  style={{
                    color: "red",
                    cursor: "pointer",
                    marginLeft: 5,
                  }}
                />
              </Media>
              :
              <Alert variant="info">Nenhum arquivo carregado!</Alert>
            }
          </div>
        </Col>
      </Row>       
    </div>
    )
  } 

  const cancelamentoInfo = ()=>{
    return (
      <div className="informacoes">
      <Row>
        <Col xs={12} lg={12} >
          <div className="item-info">
            <label>Motivo cancelamento:</label>
            <span style={{display: "flex", gap: "10px", alignItems: "center"}}>
              {chamado?.cancelamento?.motivo_cancelamento?.descricao}
            </span>        
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6} lg={6}>
          <div className="item-info">
            <label>Usuário Responsável:</label>
            <span>{ chamado?.cancelamento?.responsavel ?? "---"}
            </span>        
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className="item-info">
            <label>Data Conclusão:</label>
            <span>{ chamado?.cancelamento?.criado_em
                    ? format(parseISO(chamado?.cancelamento?.criado_em ?? ""), "dd/MM/yyyy' às 'HH:mm")
                    : "dd/mm/yyyy"
                  }
            </span>        
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="item-info">
            <label>Observação</label>              
              <span>
                {chamado?.cancelamento?.observacao}
              </span>
          </div>
        </Col>
      </Row>
    </div>
    )
  } 


  const handleCancelarEdicaoChamado = ()=>{

    setProcesso(chamado?.id_processo);
    setMeioComunicacao(chamado?.origem_ticket);
    setEmpreendimentoNome(chamado?.nome_empreendimento);
    setPrimeiroProponente({
      "nome": chamado?.proponentes?.proponente1,
      "cpf": chamado?.proponentes?.proponente1_cpf,
    });
    setSolicitante(chamado?.solicitante);
    setSituacao(chamado?.status.id_ticket_status);
    setSubSituacao(chamado?.substatus?.id_ticket_substatus ?? "");
    setAssunto(chamado?.assunto ?? "");
    setDescricao(chamado?.descricao ?? "");
    setTipo(chamado?.tipo.id_ticket_tipo ?? "");
    setCategoria(chamado?.categoria?.id_ticket_categoria ?? "");
    setModulo(chamado?.categoria?.id_modulo ?? "");
    setMotivo(chamado?.motivo?.id_ticket_motivo ?? "");

    setHabilitarEdicaoChamado(false)
  }

  const handleCancelarEdicaoQualificacao = ()=>{

    setPrioridade(chamado?.prioridade?.id_ticket_prioridade);
    setResponsavelAutorizacao(chamado?.responsaveis_autorizacao ?? []);
    setDepartamentoAutorizacao(chamado.departamentos_autorizacao ?? []);
    setResponsavelAprovacao(chamado?.responsaveis_aprovacao ?? []);
    setDepartamentoAprovacao(chamado?.departamentos_aprovacao ?? []);
    setResponsavelExecucao(chamado?.responsaveis_execucao ?? []);
    setDepartamentosExecucao(chamado?.departamentos_execucao ?? []);
    setAcompanhamento(chamado?.usuarios_acompanhamento ?? [])
    setDepartamentoAcompanhamento(chamado?.departamentos_acompanhamento ?? []);
    setTags(chamado?.tags ?? [])
    setHabilitarEdicaoQualificacao(false)
  }

  const handleCancelarEdicaoCamposDinamicos = ()=>{
    setCamposDinamicosRespostas({...chamado?.campos_dinamicos_respostas});
    setHabilitarEdicaoCamposDinamicos(false)
  }


  return (
    <div id="esquerda">
      <div className="dados-section">
        <fieldset>
          <legend>
            Dados do ticket
          </legend>
          { habilitarEdicaoChamado ?          
            <button className="btn-campos cancelar-edicao" aria-label="Cancelar Edição" onClick={()=>{handleCancelarEdicaoChamado()}}>
              <FontAwesomeIcon icon={faTimes}/>
            </button> :
            <button className="btn-campos habilitar-edicao" aria-label="Habilitar Edição" onClick={()=>{setHabilitarEdicaoChamado(true)}}>
              <FontAwesomeIcon icon={faEdit}/>
            </button>
          }
          {habilitarEdicaoChamado ?
            camposChamadoEdicao() :  
            chamadoInfo()
          }
        </fieldset>
        {!!chamado?.campos_dinamicos?.length && 
          <fieldset>
            <legend>Campos dinâmicos</legend>
            { habilitarEdicaoCamposDinamicos ?          
              <button className="btn-campos cancelar-edicao" onClick={()=>{handleCancelarEdicaoCamposDinamicos()}}>
                <FontAwesomeIcon icon={faTimes}/>
              </button> :
              <button className="btn-campos habilitar-edicao" onClick={()=>{setHabilitarEdicaoCamposDinamicos(true)}}>
                <FontAwesomeIcon icon={faEdit}/>
              </button>
            }
            {habilitarEdicaoCamposDinamicos ?
              camposDinamicosEdicao() :  
              camposDinamicosInfo()
            }
            
          </fieldset>
        }
        <fieldset style={{paddingBottom: habilitarEdicaoQualificacao ? "4rem" : "0"}}>
          <legend>Qualificação</legend>
          { habilitarEdicaoQualificacao ?          
            <button className="btn-campos cancelar-edicao" onClick={()=>{handleCancelarEdicaoQualificacao()}}>
              <FontAwesomeIcon icon={faTimes}/>
            </button> :
            <button className="btn-campos habilitar-edicao" onClick={()=>{setHabilitarEdicaoQualificacao(true)}}>
              <FontAwesomeIcon icon={faEdit}/>
            </button>
          }
          {habilitarEdicaoQualificacao ?
            camposQualificacaoEdicao() :  
            qualificacaoInfo()
          }
          
        </fieldset>
        {(chamado?.conclusao && chamado?.status?.tipo === "F") &&
          <fieldset>
            <legend>Conclusão</legend>
            {conclusaoInfo()}          
          </fieldset>
        }
        {(chamado?.cancelamento && chamado?.status?.tipo === "CA") &&
          <fieldset>
            <legend>Cancelamento</legend>
            {cancelamentoInfo()}          
          </fieldset>
        }
      </div>
      {(habilitarEdicaoChamado || habilitarEdicaoQualificacao || habilitarEdicaoCamposDinamicos) && 
        <div className="rodapeSalvar">
          <button
              onClick={() => {
                NotaInterna();
              }}
              className="btn btn-primary btn-salvar-chamado"
              style={{ marginRight: 20, alignSelf: "center" }}
            >
              Salvar
            </button>
        </div>
      }

      <ModalDommus
        open={modalConclusao}
        close={() => {
          setModalConclusao(false);
        }}
        titulo="Conclusão do chamado"
        size={"md"}
        content={
          <ConclusaoChamado
            close={() => {
              setModalConclusao(false);
            }}
            setRefresh={setRefresh}
            refresh={refresh}
            chamado={chamado}
            dados={dadosConclusao}
            atualizarChamado={atualizarChamado}
          />
        }
      />
    <ModalDommus
        open={modalNotaInterna}
        close={() => {
          setModalNotaInterna(false);
        }}
        content={
          <InternalNoteStatus
              id_ticket={chamado.id_ticket}
              closeModal={() => setModalNotaInterna(false)}
              statusMudou={() => setStatusMudou(false)}
              atualizaChamado={atualizaChamado}
          />
        }
        titulo="Nota Interna"
        size={"md"}
      />
    </div>
  );
}
